'use strict';

import React from 'react';
import autoBind from 'react-autobind';
//constants
import ApplicationConstants from '../../constants/ApplicationConstants.js';
//utils
import Products from '../../utils/Products.js';

var pageCopy = {
    email: '',
    phoneNumber: '',
    workingHours: '',
    workingDays: '',
    bookletHeader: '',
    booklet: '',
    homepage: '',
    info: '',
    firstNetHomePage: ''
};

export default class MoreMenu extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }
    getCopy() {
        pageCopy.workingHours = this.props.content.workingHours;
        pageCopy.workingDays = this.props.content.workingDays;
        
        if (window.NOA.userContext.isExisting) {
            if (window.NOA.userContext.userType === ApplicationConstants.UserTypes.ADVISER) { //adviser
                pageCopy.phoneNumber = this.props.content.phoneNumberAdviser;
                pageCopy.email = this.props.content.emailAdviser;
                pageCopy.homepage = this.props.content.homepageAdviser;
                pageCopy.firstNetHomePage = this.props.content.firstNetAdviserPage;
            } else { //existing investor
                pageCopy.email = this.props.content.email;
                pageCopy.homepage = this.props.content.homepageExistingInvestor;
                pageCopy.info = this.props.content.infoInvestor;
                pageCopy.firstNetHomePage = this.props.content.firstNetHomePage;
                pageCopy.phoneNumber = this.props.content.phoneNumber;
            }
        }
        else { //public investor
            pageCopy.phoneNumber = this.props.content.phoneNumber;
            pageCopy.email = this.props.content.emailInvestments;
        }
    }

    render () {
        let mailtoEmail,
            booklet = '',
            bookletHeader;
        
        if (this.props.content) {
            // render from content file
            this.getCopy();

            mailtoEmail = 'mailto:' + pageCopy.email;
            if(this.props.content && this.props.product.value && this.props.content[this.props.product.value]) {
                booklet = this.props.content[this.props.product.value].booklet;
            }
            bookletHeader = this.props.content.bookletHeader;
            if (Products.isAnnuity(this.props.product.value)) {
                bookletHeader = this.props.content.productInformationText;
            }
        }

        return (
            <div className="container"> { (this.props.showMoreMenu) ?
                <div className="more-menu-section">
                     <div className="row">
                        <div className="more-product-name col-md-5">
                            <h3 className="more-header">{this.props.product.label}</h3>
                            { (booklet !== '') ? <div><i className="glyphicon glyphicon-save"></i><a href={booklet} alt="pdf link per product">{bookletHeader}</a></div> 
                            : null }
                            
                            { (pageCopy.homepage !== '') ? <div><i className="glyphicon glyphicon-new-window"></i><a className="more-homepage-link" href={pageCopy.firstNetHomePage}>{pageCopy.homepage}</a></div> 
                             : null }
                            <br/><p className="more-link-message">{this.props.content.linkMessage}</p>
                        </div>
                        <div className="more-contact-details col-md-6">
                            <h3 className="more-header">Contact Details</h3>
                            <h3><i className="glyphicon glyphicon-earphone"></i><span className="more-contact-number">{pageCopy.phoneNumber}</span></h3>
                            <p className="more-details-indent">{pageCopy.workingHours}</p>
                            <p className="more-details-indent">{pageCopy.workingDays}</p>
                            <p><i className="glyphicon glyphicon-envelope"></i><a className="more-email-link" href={mailtoEmail}>{pageCopy.email}</a></p>
                         </div>
                     </div>
                 </div>
                : null }
            </div>
		);
    }
}



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/MoreMenu.jsx